import { createFileRoute } from '@tanstack/react-router'

import { LinksPage } from '@/features/links/components/links-page'
import { LINKS_PATH } from '@/features/links/data/links'
import { getTranslations } from '@/i18n/translator'
import { pageHead, SITE_URL } from '@/lib/seo'

export const Route = createFileRoute('/$locale/links')({
  loader: async ({ params }) => {
    const t = await getTranslations({ locale: params.locale, namespace: 'links.meta' })
    return { title: t('title'), description: t('description') }
  },
  head: ({ loaderData, params }) => {
    const head = pageHead({
      locale: params.locale,
      path: LINKS_PATH,
      title: loaderData?.title ?? '',
      description: loaderData?.description ?? '',
    })
    // A "link in bio" page: shared by QR code and bios, never a search result.
    // Also left out of sitemap.xml.
    return { ...head, meta: [...head.meta, { name: 'robots', content: 'noindex, follow' }] }
  },
  component: Links,
})

function Links() {
  const { locale } = Route.useParams()
  return <LinksPage pageUrl={`${SITE_URL}/${locale}${LINKS_PATH}`} />
}
